import {createContext} from "react";

import {GlobalAlertState} from "@/lib/types/alerting.ts";

export const IndexedAlertsContext = createContext<Record<number, GlobalAlertState>>({});
